import React, { useState } from "react";
import InputField from "components/fields/InputField";
import { MESSAGE_SUCCES } from "actions/types";

export function Add({ initData, onSave, validation, onCancel }) {
  const [data, setData] = useState(initData);

  const handleOnChange = (event) => {
    const { name, value } = event.target;
    initData[name] = value;
    setData((prevState) => ({ name, value }));

    if (validation[name]) {
      validation[name] = null;
    }
  };

  const handleOnChangeCheckBox = (event) => {
    const { name } = event.target;
    initData[name] = event.target.checked | 0;
    setData({ ...data, [name]: event.target.checked | 0 });
    if (validation[name]) {
      validation[name] = null;
    }
  };

  const onSaveWrapped = (event) => {
    event.preventDefault();
    onSave(initData);
  };

  return (
    <div className="w-full ps-4 sm:ps-6 lg:ps-8">
      <div className="pb-5 mb-12 border-b border-gray-200">
        <h2 className="font-bold text-gray-900 max-md:mb-3 text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight">
          Bedrijfsmedewerker
        </h2>
        <p className="mt-2 max-w-4xl text-sm text-gray-500">
          Vul hieronder de gegevens in van de medewerker die u wilt toevoegen
          aan dit bedrijf. Of wijzig de huidige gegevens van een medewerker.
        </p>
      </div>

      <form onSubmit={onSaveWrapped} className="space-y-12">
        <div className="pb-12 border-b border-gray-900/10">
          <div className="flex items-center mb-6">
            <h2 className="font-semibold text-gray-900 text-base/7">
              Persoonsgegevens
            </h2>
          </div>

          {initData.id == 0 && (
            <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
              <div className="sm:col-span-2">
                <InputField
                  lbl="Weergave naam"
                  placeholder=""
                  name="firstname"
                  validation={validation}
                  value={initData}
                  onChange={handleOnChange}
                  extraClass="w-full"
                />
              </div>

            </div>
          )}

          <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
            <div className="sm:col-span-3">
              <InputField
                lbl="Telefoonnummer"
                placeholder=""
                name="phone1"
                validation={validation}
                value={initData}
                onChange={handleOnChange}
                extraClass="w-full"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
            <div className="sm:col-span-3">
              <InputField
                lbl="E-mail"
                placeholder=""
                name="email"
                validation={validation}
                value={initData}
                onChange={handleOnChange}
                extraClass="w-full"
              />
            </div>

            {initData && !initData.user_id && initData.id > 0 && (
              <div className="flex items-center pt-8 sm:col-span-3">
                <div className="flex relative items-start">
                  <div className="flex items-center h-6">
                    <InputField
                      id="resetConnectionCode"
                      name="resetConnectionCode"
                      type="checkbox"
                      checked={initData.resetConnectionCode}
                      onChange={handleOnChangeCheckBox}
                      className="w-4 h-4 rounded border-gray-300 text-primary focus:ring-primary"
                    />
                  </div>
                  <div className="ml-3">
                    <label
                      htmlFor="resetConnectionCode"
                      className="text-sm font-medium text-gray-900"
                    >
                      Koppelcode opnieuw verzenden
                    </label>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="flex gap-3 justify-end items-center mt-6">
          <button type="button" onClick={onCancel} className="btn-secondary">
            Annuleren
          </button>
          <button type="submit" className="btn-primary">
            Wijzigingen opslaan
          </button>
        </div>
      </form>
    </div>
  );
}
